import { render, staticRenderFns } from "./PlacesCards.vue?vue&type=template&id=60af4648&"
import script from "./PlacesCards.vue?vue&type=script&lang=js&"
export * from "./PlacesCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports